<template>
<div class="component questionBox" v-if="question!=undefined">

    <div class="questionContainer">
        <div class="question">
            <p class="">
                {{question.question}}
            </p>
        </div>
        <div class="answerBox">

            <div class="content givenAnswers" v-if="question.questionType==0">
                <div class="multipleChoiceAnswers">
                    <div class="answer" v-for="answer in question.answers" @click="chooseAnswer(answer.id)" :class="{'choosenAnswer':questionAnswer==answer.id}">
                        <span class="answerText"> {{answer.answerText}}</span>
                        <span v-if="questionAnswer==answer.id" class="answerMark"><i class="fas fa-check-square"></i></span>
                        <span v-else class="answerMark"><i class="far fa-square"></i></span>

                    </div>
                </div>
            </div>

            <div class="content givenAnswers" v-if="question.questionType==1">
                <div class="customTextAnswer">
                    <textarea class="textarea" v-model="questionCustomText"></textarea>
                    <span class="button is-info sendButton" @click="addAnswerText">Antwort senden</span>
                </div>
            </div>

            <div class="content givenAnswers" v-if="question.questionType==2">
                <div class="customNumberAnswer">

                    <input type="number" class="input" v-model="questionCustomNumber" />
                    <span class="button is-info sendButton" @click="addAnswerNumber">Antwort senden</span>
                </div>
            </div>
        </div>
        <hr>
    </div>
    <!--
    <div class="card">
        <header class="card-header" @click="openModal = !openModal">
            <p class="card-header-title">
                {{question.question}}
            </p>
            <a href="#" class="card-header-icon" aria-label="more options" v-if="answered">
                Ok
            </a>
        </header>
        <div class="card-content" v-if="openModal">

            <div class="content givenAnswers" v-if="question.questionType==0">
                <div class="list is-hoverable">
                    <a class="list-item" v-for="answer in question.answers" @click="chooseAnswer(answer.id)" :class="{'choosenAnswer':questionAnswer==answer.id}">
                        {{answer.answerText}}
                    </a>
                </div>
            </div>

            <div class="content givenAnswers" v-if="question.questionType==1">
                <textarea class="input" v-model="questionCustomText"></textarea>
                <span class="button is-info sendButton" @click="addAnswerText">Antwort senden</span>
            </div>

            <div class="content givenAnswers" v-if="question.questionType==2">
                <input type="number" class="input" v-model="questionCustomNumber"></input>
                <span class="button is-info sendButton" @click="addAnswerNumber">Antwort senden</span>
            </div>

        </div>
        <footer class="card-footer">
        </footer>
    </div>
    -->
</div>
</template>

<script>
export default {
    name: 'question',
    props: ["question"],
    mounted: function () {
        if (this.question.user_answer.length > 0) {
            this.questionAnswer = this.question.user_answer[0].survey_answer_id
            this.questionCustomNumber = this.question.user_answer[0].customAnswerNumber
            this.questionCustomText = this.question.user_answer[0].customAnswerText
            this.answered = true;
        }
    },
    data() {
        return {
            data: [],
            openModal: false,
            questionAnswer: null,
            questionCustomNumber: null,
            questionCustomText: "",
            answered: false,
        }
    },
    methods: {

        chooseAnswer(id) {
            this.questionAnswer = id;
            let postData = {
                survey_question_id: this.question.id,
                survey_answer_id: id
            }

            this.sendAnswer(postData)
        },
        addAnswerNumber() {
            let postData = {
                survey_question_id: this.question.id,
                customAnswerNumber: this.questionCustomNumber
            }

            this.sendAnswer(postData)

        },
        addAnswerText() {
            let postData = {
                survey_question_id: this.question.id,
                customAnswerText: this.questionCustomText
            }

            this.sendAnswer(postData)
        },

        sendAnswer(postData) {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }
        this.sendInfoMessage({'loading':true})

            this.$axios.post(this.$backendURL + "/survey/answer", postData, {
                headers: headerData
            }).then(function (result) {
                        this.sendInfoMessage({'text':this.$t('enaq_translation_surveys_answer_saved'),'duration':'8'})

                this.$emit("onAnswerAdd");
                this.openModal = false;
                this.answered = true;

            }.bind(this))
        },

    },
    computed: {},
}
</script>

<style scoped>
.choosenAnswer .answerMark {color:green;}

.sendButton {
    margin-top: 10px;
}

.questionContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
}

.question {
    display: inline-block;
    width: 50%;
    -webkit-box-shadow: 0px 0px 5px 3px rgba(0, 0, 0, 0.38);
    -moz-box-shadow: 0px 0px 5px 3px rgba(0, 0, 0, 0.38);
    box-shadow: 0px 0px 5px 3px rgba(0, 0, 0, 0.38);
    margin: 1vh 0;
    font-size: 2em;
    border-radius: 40px;
    padding: 10px;
    height: 100%;
}

.answerBox {
    display: inline-block;
    width: 50%;
    padding-left: 5%
}

.multipleChoiceAnswers {
    border-top: 1px solid grey;
    margin: 0 1vw;
}

.multipleChoiceAnswers .answer {
    display: block;
    font-size: 1.8em;
    border-bottom: 1px solid grey;
    padding: 5px 0;
}

.multipleChoiceAnswers .answerText {
    display: inline-block;
    width: 80%;

}

.multipleChoiceAnswers .answerMark {
    display: inline-block;
    width: 20%;

}

.customTextAnswer, .customNumberAnswer {
    padding: 0 20px;
    padding-top: 2em;
}


</style>
